import React from "react";
import { PIN } from "../../../core/theme/reportTheme";
import { PINNED_ALWAYS_SHOWN } from "../../../core/data/advertiserOverviewText";

function PinIcon() {
  return (
    <svg className={PIN.chipIcon} width="11" height="11" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M16 3l5 5-3 1-4 4 1 5-2 2-4-4-5 5-1-1 5-5-4-4 2-2 5 1 4-4z" />
    </svg>
  );
}

function ShareIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="18" cy="5" r="3" /><circle cx="6" cy="12" r="3" /><circle cx="18" cy="19" r="3" />
      <path d="M8.6 13.5l6.8 4M15.4 6.5l-6.8 4" />
    </svg>
  );
}

// Right end of the tab bar on Advertiser Overview and the channel pages:
// the pinned advertiser "x.co.uk · Change ×", a small share icon and, when the
// Business type filter hides the pinned advertiser's own type, a note. Kept
// compact, and it gives way (long names shortened with "…") so the page tabs
// are always the same size as on Market Overview.
export default function PinChip({ pinned, onChange, onClear, showTypeNote }) {
  if (!pinned) {
    return (
      <div className={PIN.area}>
        <button type="button" onClick={onChange} className={PIN.chipEmpty}><PinIcon /> Pin an advertiser</button>
      </div>
    );
  }
  return (
    <div className={PIN.area}>
      {showTypeNote && <span className={PIN.note} title={PINNED_ALWAYS_SHOWN}>{PINNED_ALWAYS_SHOWN}</span>}
      <div className={PIN.chip} title={`Pinned: ${pinned.displayName}`}>
        <PinIcon />
        <span className={PIN.chipName}>{pinned.displayName}</span>
        <span className="text-violet-300 shrink-0">·</span>
        <button type="button" onClick={onChange} className={PIN.chipLink}>Change</button>
        <button type="button" onClick={onClear} className={PIN.chipClear} aria-label="Clear pin" title="Clear pin">×</button>
      </div>
      {/* The tooltip sits on a wrapper: browsers don't show one on a disabled button. */}
      <span title={`Share with ${pinned.displayName} - coming soon`} className="shrink-0">
        <button type="button" disabled className={PIN.share} aria-label={`Share with ${pinned.displayName}`}><ShareIcon /></button>
      </span>
    </div>
  );
}
